/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useRef, useState, useEffect } from 'react';
import { toast } from 'react-toastify';

// eslint-disable-next-line object-curly-newline
export function GovBrDateInput({
  value,
  setValue,
  label,
  includeTime = false,
}) {
  const inputRef = useRef();
  const [input, setInput] = useState('');

  // Validar formato de data DD/MM/YYYY
  const isValidDate = (date) => {
    if (!date) return false;
    const dateRegex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
    if (!dateRegex.test(date)) return false;
    const [, day, month, year] = dateRegex.exec(date);
    const intDay = parseInt(day, 10);
    const intMonth = parseInt(month, 10);
    const intYear = parseInt(year, 10);
    if (intMonth < 1 || intMonth > 12) return false;
    if (intDay < 1 || intDay > 31) return false;
    if (intYear < 1900 || intYear > 2100) return false;
    return true;
  };

  // Validar formato de hora HH:MM
  const isValidTime = (time) => {
    if (!time) return false;
    const timeRegex = /^([0-1][0-9]|2[0-3]):([0-5][0-9])$/;
    return timeRegex.test(time);
  };

  // Converter e definir o valor conforme o formato necessário
  const convertAndSetValue = (text) => {
    // Verificar se o texto tem um formato válido
    const parts = text.split(' ');

    // Modo com data e hora
    if (includeTime && parts.length === 2) {
      const [datePart, timePart] = parts;
      if (isValidDate(datePart) && isValidTime(timePart)) {
        const [day, month, year] = datePart.split('/');
        setValue(`${timePart}-${year}-${month}-${day}`);
        return;
      }
    }
    // Apenas data - formato original ou novo formato YYYY-MM-DD
    else if (parts.length === 1 && isValidDate(parts[0])) {
      const [day, month, year] = parts[0].split('/');
      if (includeTime) {
        // Formato YYYY-MM-DD quando includeTime=true, sem hora
        setValue(`${year}-${month}-${day}`);
      } else {
        // Formato original DD/MM/YYYY para o componente padrão
        setValue(parts[0]);
      }
      return;
    }

    // Se chegou aqui, não é um formato válido completo ainda
    setValue(text);
  };

  // Inicializar a entrada a partir do valor existente
  useEffect(() => {
    if (!value) {
      setInput('');
      return;
    }

    // Modo com suporte a data e hora
    if (includeTime && value.includes('-')) {
      const parts = value.split('-');

      // Formato é HH:mm-YYYY-MM-DD com 4 partes
      if (parts.length === 4) {
        const [time, year, month, day] = parts;
        setInput(`${day}/${month}/${year} ${time}`);
      }
      // Formato é YYYY-MM-DD com 3 partes
      else if (parts.length === 3) {
        const [year, month, day] = parts;
        setInput(`${day}/${month}/${year}`);
      } else {
        setInput(value);
      }
    } else if (includeTime && value.includes('/')) {
      // Formato original DD/MM/YYYY mas com includeTime=true
      setInput(value);
    } else {
      // Modo padrão, apenas data
      setInput(value);
    }
  }, [value, includeTime]);

  // Função para formatar a data durante a digitação
  const handleChange = (e) => {
    let newValue = e.target.value;

    if (includeTime) {
      // Modo com suporte a data e hora
      // Remove caracteres não numéricos, barras, espaços e dois pontos
      newValue = newValue.replace(/[^\d/: ]/g, '');

      // Formato automático para data (DD/MM/YYYY)
      if (newValue.length > 0 && !newValue.includes(' ')) {
        // Apenas formatando a parte da data
        if (newValue.length > 2 && newValue.charAt(2) !== '/')
          newValue = `${newValue.slice(0, 2)}/${newValue.slice(2)}`;
        if (newValue.length > 5 && newValue.charAt(5) !== '/')
          newValue = `${newValue.slice(0, 5)}/${newValue.slice(5)}`;
        // Limitar a 10 caracteres para a parte da data
        if (newValue.length > 10)
          newValue = `${newValue.slice(0, 10)} ${newValue.slice(10)}`;
      } else if (newValue.includes(' ')) {
        // Formatar a parte da hora após o espaço
        const [datePart, timePart] = newValue.split(' ');

        // Formatar data
        let formattedDate = datePart;
        if (formattedDate.length > 2 && formattedDate.charAt(2) !== '/')
          formattedDate = `${formattedDate.slice(0, 2)}/${formattedDate.slice(
            2,
          )}`;
        if (formattedDate.length > 5 && formattedDate.charAt(5) !== '/')
          formattedDate = `${formattedDate.slice(0, 5)}/${formattedDate.slice(
            5,
          )}`;
        if (formattedDate.length > 10)
          formattedDate = formattedDate.slice(0, 10);

        // Formatar hora
        let formattedTime = timePart || '';
        if (formattedTime.length > 2 && formattedTime.charAt(2) !== ':')
          formattedTime = `${formattedTime.slice(0, 2)}:${formattedTime.slice(
            2,
          )}`;
        if (formattedTime.length > 5) formattedTime = formattedTime.slice(0, 5);

        newValue = `${formattedDate}${
          formattedTime ? ` ${formattedTime}` : ''
        }`;
      }
    } else {
      // Modo original, apenas data
      // Remove todos os caracteres não numéricos e barras
      newValue = newValue.replace(/[^0-9/]/g, '');

      // Limita a quantidade de caracteres para 10 (DD/MM/YYYY)
      if (newValue.length > 10) newValue = newValue.substring(0, 10);

      // Formata a string da data
      if (newValue.length > 2 && newValue.charAt(2) !== '/')
        newValue = `${newValue.slice(0, 2)}/${newValue.slice(2)}`;
      if (newValue.length > 5 && newValue.charAt(5) !== '/')
        newValue = `${newValue.slice(0, 5)}/${newValue.slice(5)}`;
    }

    setInput(newValue);
    convertAndSetValue(newValue);
  };

  // Validar o formato ao perder o foco
  const handleBlur = () => {
    if (!input) return;

    const parts = input.split(' ');
    const datePart = parts[0];
    const timePart = parts[1];

    let isValid = true;
    let errorMessage = '';

    // Validar data
    if (!isValidDate(datePart)) {
      isValid = false;
      errorMessage = 'Formato de data inválido. Use DD/MM/YYYY';
    } else if (includeTime && timePart && !isValidTime(timePart)) {
      // Validar hora se fornecida e se o modo includeTime estiver ativo
      isValid = false;
      errorMessage = 'Formato de hora inválido. Use HH:MM (24h)';
    }

    if (!isValid) {
      toast.warning(errorMessage);
      setInput('');
      setValue('');
    } else {
      // Garantir que o valor está no formato correto
      convertAndSetValue(input);
    }
  };

  return (
    <div className="col-sm-2 mb-1">
      <div className="br-select">
        <div className="br-input">
          <label htmlFor={label}>{label}</label>
          <input
            ref={inputRef}
            value={input}
            onChange={handleChange}
            onBlur={handleBlur}
            id={label}
            type="text"
            placeholder={includeTime ? 'DD/MM/YYYY HH:MM' : 'DD/MM/YYYY'}
          />
        </div>
      </div>
    </div>
  );
}
